import { css } from '@emotion/react';
import React from 'react';

export type LinkButtonProps = React.ButtonHTMLAttributes<HTMLButtonElement>;

export const LinkButton: React.FC<LinkButtonProps> = ({ className, ...props }) => {
  return <button className={className} css={styles.button} type="button" {...props} />;
};

const styles = {
  button: css({
    backgroundColor: 'transparent',
    border: 'none',
    cursor: 'pointer',
    fontSize: 'inherit',
    outline: 'none',
    padding: '0',

    ':focus-visible': {
      outline: '3px solid rgb(0, 160, 255)',
      outlineOffset: '-2px',
    },
  }),
};
